import React, { useState } from 'react';

interface BrandLogoProps {
  collapsed?: boolean;
  className?: string;
  height?: number | string;
  logoUrl?: string | null;
  brandName?: string | null;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ 
  collapsed = false, 
  className = '', 
  height = 22,
  logoUrl,
  brandName
}) => {
  const [imgError, setImgError] = useState(false);
  const displayName = brandName || 'CRM Platform Suite';

  // Ícone Vetorial Oficial da Identidade (crm-symbol.svg)
  const defaultVectorIcon = (
    <svg 
      viewBox="0 0 120 120" 
      height={height} 
      width={height} 
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: 'block' }}
    >
      <defs>
        <linearGradient id="crmPrimary" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#18b7d8"></stop>
          <stop offset="100%" stopColor="#7dd8ea"></stop>
        </linearGradient>
        <linearGradient id="crmAccent" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#e1a34a"></stop>
          <stop offset="100%" stopColor="#f4c97d"></stop>
        </linearGradient>
      </defs>
      <rect x="10" y="18" width="42" height="84" rx="16" fill="url(#crmPrimary)"></rect>
      <rect x="68" y="18" width="42" height="84" rx="16" fill="url(#crmAccent)"></rect>
      <path d="M34 38C44 38 52 46 52 56V64C52 74 44 82 34 82H26V38H34Z" fill="#08131c"></path>
      <path d="M86 38H94V82H86C76 82 68 74 68 64V56C68 46 76 38 86 38Z" fill="#08131c"></path>
      <circle cx="60" cy="60" r="10" fill="#eef8fb"></circle>
    </svg>
  );

  const hasCustomLogo = Boolean(logoUrl && !imgError);

  if (collapsed) {
    if (hasCustomLogo) {
      return (
        <img
          src={logoUrl!}
          alt={displayName}
          onError={() => setImgError(true)}
          className={className}
          style={{
            height: height,
            width: height,
            objectFit: 'contain',
            borderRadius: '4px',
            display: 'block'
          }}
          title={displayName}
        />
      );
    }
    return (
      <div className={className} style={{ display: 'block' }} title={displayName}>
        {defaultVectorIcon}
      </div>
    );
  }

  return (
    <div 
      className={`brand-logo-vector ${className}`}
      style={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        gap: '8px', 
        background: 'transparent',
        userSelect: 'none',
        maxWidth: '100%',
        overflow: 'hidden'
      }}
      title={displayName}
    >
      {hasCustomLogo ? (
        <img
          src={logoUrl!}
          alt={displayName}
          onError={() => setImgError(true)}
          style={{
            height: height,
            maxHeight: typeof height === 'number' ? `${height}px` : height,
            maxWidth: '130px',
            objectFit: 'contain',
            borderRadius: '4px',
            display: 'block'
          }}
        />
      ) : (
        <>
          {defaultVectorIcon}
          <span 
            className="brand-logo-text"
            style={{ 
              fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
              fontWeight: 700,
              fontSize: '13px',
              letterSpacing: '-0.02em',
              lineHeight: 1.2,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {displayName}
          </span>
        </>
      )}
    </div>
  );
};
